import permanentData from './permanentData';
import sessionData from './sessionData';

export default {
    ...permanentData,
    ...sessionData,
};
